import { futureActionAcceptableResults, detectionCategory, detectionType, ConfigType, ConfigSex, categoryType, operationLog, packageProductTypes, labOrderSaleFrom, typeName, holidayType } from 'json/lab-order'
export function formatActionAcceptableResult (value) {
  for (let item of futureActionAcceptableResults) {
    if (item.key === value) {
      return item.value
    }
  }
  if (value) {
    console.error('[formatActionAcceptableResult]方法未找到对应的item', value)
  }
  return ''
}
export function formatDetectionCategory (key) {
  for (let item of detectionCategory) {
    if (item.key === key) {
      return item.value
    }
  }
  return ''
}
export function formatConfigSex (key) {
  for (let item of ConfigSex) {
    if (item.key === key) {
      return item.value
    }
  }
  return ''
}
export function formatdetection (value) {
  for (let item of detectionType) {
    if (item.value === value) {
      return item.key
    }
  }
  return ''
}
export function formatConfigType (key) {
  for (let item of ConfigType) {
    if (item.key === key) {
      return item.value
    }
  }
  return ''
}
export function formatCategoryToType (key) {
  for (let item of categoryType) {
    if (item.key === key) {
      return item.value
    }
  }
  return ''
}
export function formatOperationLog (value) {
  for (let item of operationLog) {
    if (item.key === value) {
      return item.value
    }
  }
  return ''
}
export function compare (prop) {
  return function (obj1, obj2) {
    var val1 = obj1[prop]
    var val2 = obj2[prop]; if (val1 < val2) {
      return -1
    } else if (val1 > val2) {
      return 1
    } else {
      return 0
    }
  }
}
export function formatPackageProductType (key) {
  for (let item of packageProductTypes) {
    if (item.key === key) {
      return item.value
    }
  }
  return ''
}
export function formatSaleFrom (value) {
  for (let item of labOrderSaleFrom) {
    if (item.value === value) {
      return item.label
    }
  }
  return ''
}
export function getTypeName (value) {
  for (let item of typeName) {
    if (item.value === value) {
      return item.label
    }
  }
  return ''
}
export function formatHolidayType (value) {
  for (let item of holidayType) {
    if (item.value === value) {
      return item.label
    }
  }
  return ''
}
